import { ScopeCustomFieldValue } from '@app/features/scope-overview/model/scope-custom-field-value.model';

export class CompanyScopeCustomFieldsDefinition {
  customFields!: Array<ScopeCustomFieldValue>

  getName(id: string): string | undefined {
    return this.customFields.find(field => field.id === id)?.name;
  }
}
